'use strict';

window.addEventListener('DOMContentLoaded', function() {
  function init() {
    initSearchForm();
    initCollectionFilters();
  }
  
  function initSearchForm() {
    const searchForms = document.querySelectorAll("form[role=search]");
  
    searchForms.forEach(searchForm => {
      searchForm.addEventListener("submit", () => {
        const searchField = searchForm.querySelector("input[name=q]");
        
        if (!searchField) { return; }
          
        const terms = searchField.value.split(" ");
        const starredTerms = terms.map(term => {
          if (!term) { return ''; }
          
          // Contains a star?  Don't add one.
          if (term.indexOf('*') != -1) { return term; }
          
          return term + '*';
        });
        
        searchField.value = starredTerms.join(' ');
      });
    });
  }
  
  function initCollectionFilters() {
    const filtersEl = document.querySelector('.collection-filters');
    
    if (!filtersEl) { return; }
    
    // Note that we have to grab clicks at the container level rather than handling them on the elements themselves, because the elements are reloaded 
    // when tags are added.
    filtersEl.addEventListener('click', e => {
      const target = e.target;
      if (target.matches('.collection-filter__title')) {
        // Clear all existing "open" classes
        const filterTitles = Array.from(document.querySelectorAll('.collection-filter__title'));
        filterTitles.filter(filterTitle => filterTitle !== target).forEach(filterTitle => filterTitle.closest('.collection-filter__group').classList.remove('collection-filter--open'));
        target.closest('.collection-filter__group').classList.toggle('collection-filter--open');
      }
    });
  }
  
  init();
});